require('./ctxContentSwitcher.style.scss');

const dependencies = ['$element', '$scope', '$timeout'];
const ANIM_DELAY = 0;
class ContentSwitcherController {
    constructor() {
        require('../utils/injectDeps')(this, arguments);
        this.panelNames = [];
        this.animCount = 0;
    }

    $onInit() {
        this.$element.css({ 'display': 'block' });
    }

    $postLink() {
        let switcher = this.$element.find('.ctx-content-switcher');
        this.postLinkPrepare(switcher, this.animateSwitcher);
    }

    postLinkPrepare(switcherElement, switcherAnimate) {
        if (!switcherAnimate) {
            this.prepare(switcherElement);
            return;
        }
        this.$timeout(() => {
            let switchPanel = switcherElement.find('.ctx-switch-panel');
            let height = switchPanel[0] && switchPanel[0].getBoundingClientRect() ? Math.round(switchPanel[0].getBoundingClientRect().height) : 0;
            this.prepare(switcherElement);
            switcherElement.css({ height: height + "px" });
        }, 200);
    }

    prepare(switcherElement) {
        this.$scope.$watch(() => this.activeName, () => {
            switcherElement.css('overflow', 'hidden');
            this.animCount++;
            let firstInput;
            this.$timeout(() => {
                this.animCount--;
                firstInput = switcherElement.find('input').first();
                if (firstInput && firstInput[0]) {
                    firstInput.focus();
                }
            }, ANIM_DELAY);
        });
        this.$element.find('.ctx-switch-panel').each((i, panel) => {
            this.$timeout(() => panel.style.transition = `transform cubic-bezier(0.250, 0.460, 0.450, 0.940) ${ANIM_DELAY}ms, opacity cubic-bezier(0.250, 0.460, 0.450, 0.940) ${ANIM_DELAY}ms`);
            this.poly_event_listener(panel, 'TransitionEnd', () => this.$timeout(() => !this.animCount ? switcherElement.css('overflow', 'visible') : null, Math.floor(ANIM_DELAY / 10)));
        });
    }

    register(names) {
        this.panelNames.push(names);
    }

    isActive(names) {
        return names.split('|').indexOf(this.activeName) >= 0;
    }

    getPosition(names) {
        let activeNames = null;
        (this.panelNames || []).forEach(panelNames => {
            activeNames = activeNames || (panelNames.split('|').indexOf(this.activeName) >= 0 ? panelNames : '');
        });
        return ((this.panelNames || []).indexOf(names) < (this.panelNames || []).indexOf(activeNames)) ? 'right' : 'left';
    }

    poly_event_listener(element, type, callback) {
        let pfx = ['webkit', 'moz', 'MS', 'o', ''];
        for (let i = 0; i < pfx.length; i++) {
            if (pfx[i] === '') type = type.toLowerCase();
            element.addEventListener(pfx[i] + type, callback, false);
        }
    }
}

ContentSwitcherController.$inject = dependencies;

const contentSwitcherComponent = {
    controller: ContentSwitcherController,
    template: '<div class="ctx-content-switcher" ng-transclude></div>',
    transclude: true,
    replace: false,
    bindings: {
        activeName: '<activePanel',
        animateSwitcher: '<?'
    },
    scope: {}
};

module.exports = contentSwitcherComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxContentSwitcher/ctxContentSwitcher.component.js